import { useRef } from 'react'
import './App.css'
import styled from 'styled-components'
import Navbar from '../src/component/Navbar'
import HeroSection from '../src/component/HeroSection'
import image from '../src/assets/images/background.svg'
import Accordion from '../src/component/Accordion'
import { Spacer } from './component/Spacer'
import Footer from './component/Footer'

const Wrapper = styled.div`
  height: auto;
`
const Data = [
  {
    title: 'What is an NFT?',
    content:
      'A non-fungible token is a unique digital identifier that is recorded on a blockchain, and is used to certify ownership and authenticity.',
  },
  {
    title: 'What is Metamask?',
    content:
      'MetaMask is a software cryptocurrency wallet used to interact with the Ethereum blockchain. It allows users to access their Ethereum wallet through a browser extension or mobile app, which can then be used to interact with decentralized applications.',
  },
  {
    title: 'What is Bichi Mao?',
    content: 'https://www.instagram.com/bichi.mao/',
  },
]

function App() {
  const topRef = useRef(null)
  const roadmapRef = useRef(null)
  const faqRef = useRef(null)

  return (
    <div className="App">
      <Wrapper ref={topRef} style={{ backgroundImage: `url(${image})` }}>
        <Navbar tr={topRef} rr={roadmapRef} fr={faqRef} />
        <HeroSection sectionRef={roadmapRef} />
        <div ref={faqRef}>
          {Data.map((item, index) => {
            return (
              <Accordion
                title={item.title}
                content={item.content}
                key={index}
              />
            )
          })}
        </div>
        <Spacer height="80px" />
        <Footer />
        <Spacer height="80px" />
      </Wrapper>
    </div>
  )
}

export default App
